module.exports = __webpack_public_path__ + "static/api_logo-b966ae690e88f02e57d5f889ad82b062.jpg";